import React, { useState, Fragment, useEffect } from "react";
import {
  openStnInvoice,
  copyStnInvoice,
} from "../../utils";
import { useParams } from "react-router-dom";
import {useEscalationClaimMutation, useHardEscalateMutation} from "../../services/jobsApi";

import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import calendarIcon from "../../img/calendar.svg";
import addressIcon from "../../img/address.svg";

import BasicModalInformation from "../../components/basicModalInformation";
import JobEditTabsHeaderSkeleton from "../jobDetailsTabs/jobEditTabsHeaderSkeleton";
import { eventDatesFormatter, parseToEasternTime } from "../../utils/dates";
import { IconButton, Popover } from "@mui/material";
import copyIcon from '../../img/copy-icon.svg';
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";

function ShowEscalationButton({ escalationStatus, takeOwnerShip, localEscalationClaim, getIdOfCurrentAdminInCharge, claimingEscInProgress }) {
  const user= useSelector(selectCurrentUser);
  console.log(getIdOfCurrentAdminInCharge(), user.id)

  return (
    escalationStatus == "ESCALATED IN PROCESS" && getIdOfCurrentAdminInCharge() == user.id ?

      <Button
        variant="contained"
        disabled
        sx={{
          borderRadius: "2em",
          marginBottom: "1em",
          width: '190px',
          backgroundColor: 'var(--red)!important',
          color: 'white !important'
        }}


      >
        Issue - In Process
      </Button>
      :
      (escalationStatus == "ESCALATED IN PROCESS" || escalationStatus == "NOT ESCALATED" ?
        <Button
          onClick={() => takeOwnerShip()}
          style={{ color: "white" }}
          variant="contained"
          sx={{ borderRadius: "2em", marginBottom: "1em", width: '190px' }}
        >
          Take Ownership
        </Button>
        :
        <Button
          disabled= {claimingEscInProgress}
          variant="contained"
          sx={{ borderRadius: "2em", marginBottom: "1em", width: '190px' }}
          onClick={localEscalationClaim}
        >
          Process Issue
        </Button>)
  )
}

export default function JobEditTabsHeader({ jobInfo, setJobInfo, getJobInfo }) {

  const [initSendHardScalation] = useHardEscalateMutation();
  const [initEscalationClaim, {isLoading: escalationClaimIsLoading}] = useEscalationClaimMutation();

  let { job={}, escalationActive, event } = jobInfo || {};
  let { jobId } = useParams();
  const user= useSelector(selectCurrentUser);

  let [claimingEscInProgress, setClaimingEscInProgress] = useState(false);

  let [isLoading, setIsLoading] = useState(false);

  let [hardEscalationError, setHardEscalationError] = useState(null);
  //A: save hard escalations errors here (from api).
  const [open, setOpen] = useState(false);
  const [showCopy, setShowCopy] = useState(false);


  const handleClose = () => setOpen(false);

  let escalationStatus = "NOT ESCALATED";

  if (escalationActive != null && escalationActive.id) escalationStatus = "ESCALATED";

  if (escalationActive?.issueResolvedSTNUserID != null) escalationStatus = "ESCALATED IN PROCESS";

  async function localEscalationClaim() {
    //U: onClick event whe admin click the process button
    try {
      setClaimingEscInProgress(true);
      let res= await initEscalationClaim({escalationId:escalationActive.id, adminId:user.id}).unwrap();
      console.log("escalationClaim: " , res);
      if(res.status == "OK"){
        setJobInfo( (prevJob) => ({...prevJob, escalationActive:  res.res}));
      }else{
        throw new Error((res.message && res.message != "" && res.message) || "error claiming escalation");
      }
      // window.location.reload();
    } catch (e) {
      console.log("error claiming escalation: " + e);
      console.log("error claiming escalation: " + JSON.stringify(e));
      setHardEscalationError("There was an error claiming escalation of this job.");
    }finally{
      setClaimingEscInProgress(false);
    }
  }

  async function takeOwnerShip() {
    //setClaimingEscInProgress(true);
    setJobInfo(null);  //A: trigger loading skeleton
    let jobScalation = {
      "jobId": jobId,
      "hiveUserId": user.id,
      // "issueReasonId": 6, //TODO: get all reasons id and select one available. . 6:other
      "MainReasonId": 6,
      "SubReasonId": 28,
      "issueNote": "Take ownership of escalation"
    }

    console.log("escalation information: ", jobScalation);
    try {
      let res = await initSendHardScalation(jobScalation).unwrap();
      console.log("res: " + JSON.stringify(res));
      getJobInfo(); //A: get job info again
    } catch (error) {
      console.log(JSON.stringify(error))
      if(error.message == "Job is already completed"){
        setHardEscalationError("You cannot take ownership, as this job has been completed. Check purchase history for more details");
      }else{
        setHardEscalationError("There was an error taking ownership of this job.");
      }
    }
  }

  function statusColor(job) {
    if (job.status) {
      switch (job.status.name) {
        case "Completed":
          return (
            <span style={{ color: "var(--green)" }}>{job.status.name}</span>
          );
        case "Escalated":
          return (
            <span style={{ color: "var(--orange)" }}>{job.status.name}</span>
          );
        case "Active":
          return (
            <span style={{ color: "var(--green)" }}>{job.status.name}</span>
          );
        case "Canceled":
          return <span style={{ color: "var(--red)" }}>{job.status.name}</span>;
        case "In Progress":
          return (
            <span style={{ color: "var(--amber)" }}>{job.status.name}</span>
          );
        case "Inactive":
          return (
            <span style={{ color: "var(--grey)" }}>{job.status.name}</span>
          );
      }
    }
  }

  useEffect(() => {
    if (job && job.id) {
      console.log(job);
      setIsLoading(false);
    }
  }, [job]);

  function getNameOfCurrentOwner() {
    if (!job || !job.currentOwnerHiveUser) return "-";
    return `${job.currentOwnerHiveUser.firstName} ${job.currentOwnerHiveUser.lastName}`;
  }

  function getNameOfCurrentAdminInCharge() {
    if (!escalationActive || escalationActive.issueResolvedSTNUserID == null)
      return "-";
    return `${escalationActive.issueResolvedSTNUser.firstName} ${escalationActive.issueResolvedSTNUser.lastName}`;
  }

  function getIdOfCurrentAdminInCharge() {
    if (!escalationActive || escalationActive.issueResolvedSTNUserID == null)
      return "-";
    return escalationActive.issueResolvedSTNUser.id;
  }


  return (
    <Fragment>
      {isLoading || !jobInfo ? (
        <JobEditTabsHeaderSkeleton />
      ) : (
        <div className="job-edit-header">
          <div className="row-modal">
            <div>
              <div className="row-modal" style={{ alignItems: 'center' }} >
                <p
                  style={{
                    fontSize: "var(--caption)",
                    fontWeight: "600",
                    margin: "0",
                  }}
                >
                  Related Invoice: <a onClick={() => openStnInvoice(job.invoiceID)}>{job.invoiceID ? job.invoiceID : "-"}</a>
                </p>
                <IconButton 
                variant="text"
                sx={{ margin: '0 0 0 0.5em' }} 
                onClick={async() => {
                  await (copyStnInvoice(job.invoiceID))
                   setShowCopy(true)
                   }}
                > 
                <img src={copyIcon} id='copyButton' alt='copy icon' height='14px' /> 
                </IconButton>

                <Popover
                  id="copyButton"
                  open={showCopy}
                  anchorEl={document.getElementById("copyButton")}
                  onClose={() => setShowCopy(false)}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <p style={{ margin: "0", padding: "0.5em", fontSize: "0.85rem", fontWeight: 700, color: 'var(--orange)' }} >
                    Copied!
                  </p>
                </Popover>

              </div>

              <p style={{ fontSize: "var(--caption)", margin: "0 0 0.5em 0" }}>
                ID: {job.id}
              </p>
              <p style={{ fontSize: "var(--caption)", margin: "0 0 0.5em 0" }}>
                {parseToEasternTime(job.createdOn)}
              </p>
            </div>
            <div>
              <p style={{ fontSize: "0.875rem", margin: "0 0 0.5em 0" }}>
                Status:{" "}
                <span style={{ fontWeight: "700" }}>{statusColor(job)}</span>{" "}
              </p>
              <p style={{ fontSize: "0.875rem", margin: "0 0 0.5em 0" }}>
                Assigned to:{" "}
                <span style={{ fontWeight: "700" }}>
                  {getNameOfCurrentOwner()}
                </span>{" "}
              </p>
              <p style={{ fontSize: "0.875rem", margin: "0 0 1em 0" }}>
                Admin in Process:{" "}
                <span style={{ fontWeight: "700" }}>
                  {getNameOfCurrentAdminInCharge()}
                </span>{" "}
              </p>
            </div>
          </div>

          <div className="row-modal" style={{ alignItems: "flex-end" }}>
            <div>
              <h4
                style={{
                  color: "var(--orange)",
                  fontWeight: "600",
                  margin: "0 0 1em 0",
                }}
              >
                {event.name}
              </h4>
              <div
                className="row-modal"
                style={{ margin: "0 0 1em 0", justifyContent: "flex-start" }}
              >
                <img
                  src={calendarIcon}
                  alt="calendar icon"
                  height="18px"
                  width="18px"
                  style={{ marginRight: "0.5em" }}
                />
                <p style={{ fontSize: "var(--p2)", margin: "0" }}>
                  {eventDatesFormatter(event.date)}
                </p>
              </div>
              <div
                className="row-modal"
                style={{ margin: "0 0 1em 0", justifyContent: "flex-start" }}
              >
                <img
                  src={addressIcon}
                  alt="address icon"
                  height="18px"
                  width="18px"
                  style={{ marginRight: "0.5em" }}
                />
                <p
                  style={{ fontSize: "var(--p2)", margin: "0" }}
                >{`${event.venue.name} (${event.venue.city}, ${event.venue.state})`}</p>
              </div>
            </div>
            <div className="column-modal" style={{ margin: "0" }}>

              {
                job?.status?.name !== "Completed" &&  //A: only if the job is not completed we can show this button
                <ShowEscalationButton
                 claimingEscInProgress={claimingEscInProgress}
                  escalationStatus={escalationStatus}
                  takeOwnerShip={takeOwnerShip}
                  localEscalationClaim={localEscalationClaim}
                  getIdOfCurrentAdminInCharge={getIdOfCurrentAdminInCharge}
                />
                /*A: force escalation or take escalation button */
              }


              <Button
                variant="outlined"
                sx={{ borderRadius: "2em", width: "100%" }}
              >
                <Link
                  to="/dashboard/admintools?tab_index=0"
                  style={{ color: "var(--orange)" }}
                >
                  Back to Jobs
                </Link>
              </Button>

            </div>

          </div>

          <BasicModalInformation
            title= {hardEscalationError}
            open= {hardEscalationError}
            handleClose={()=>{window.location.reload()}}
          />
        </div>
      )}
    </Fragment>
  );
}
